import { render } from "./NotFoundPage.vue?vue&type=template&id=4359acc0&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=4359acc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4359acc0"]])

export default __exports__